import { render, staticRenderFns } from "./navmenu.vue?vue&type=template&id=4f73b469&scoped=true&"
import script from "./navmenu.vue?vue&type=script&lang=js&"
export * from "./navmenu.vue?vue&type=script&lang=js&"
import style0 from "./navmenu.vue?vue&type=style&index=0&id=4f73b469&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f73b469",
  null
  
)

export default component.exports